import { useEffect, useState } from "react";
import api, { fmtEUR } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export function CashPayDialog({ invoice, open, onClose, onDone }) {
  const [form, setForm] = useState({ amount: "", date: "", note: "" });

  useEffect(() => {
    if (open && invoice) {
      setForm({
        amount: String(Math.round(((invoice.total || 0) - (invoice.paid_amount || 0)) * 100) / 100),
        date: invoice.invoice_date || new Date().toISOString().slice(0, 10),
        note: "",
      });
    }
  }, [open, invoice]);

  const confirm = async () => {
    const amount = Number(form.amount);
    if (!amount || amount <= 0) { toast.error("Importe inválido"); return; }
    try {
      const r = await api.post(`/payables/${invoice.id}/payments`,
        { amount, date: form.date, note: form.note || null, method: "efectivo" });
      toast.success(`Pago registrado — estado: ${r.data.payment_status}, pendiente: ${fmtEUR(r.data.pending)}`);
      onClose();
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error al registrar el pago");
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="invoice-pay-dialog">
        <DialogHeader><DialogTitle className="font-heading">Registrar pago en efectivo</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="text-sm text-slate-600">
            {invoice?.supplier_name} · {invoice?.invoice_number || "s/n"} · pendiente{" "}
            {fmtEUR((invoice?.total || 0) - (invoice?.paid_amount || 0))}
          </div>
          <div className="space-y-1.5">
            <Label>Importe</Label>
            <Input data-testid="invoice-pay-amount" type="number" step="0.01" value={form.amount}
              onChange={(e) => setForm({ ...form, amount: e.target.value })} />
          </div>
          <div className="space-y-1.5">
            <Label>Fecha</Label>
            <Input data-testid="invoice-pay-date" type="date" value={form.date}
              onChange={(e) => setForm({ ...form, date: e.target.value })} />
          </div>
          <div className="space-y-1.5">
            <Label>Nota (opcional)</Label>
            <Input data-testid="invoice-pay-note" value={form.note}
              onChange={(e) => setForm({ ...form, note: e.target.value })} />
          </div>
          <div className="text-sm border border-slate-200 rounded-md px-3 py-2 bg-slate-50 font-medium" data-testid="invoice-pay-method">Efectivo</div>
          <p className="text-xs text-slate-500">El registro manual solo es válido en efectivo — los pagos por tarjeta o cuenta bancaria se concilian con el estado de cuenta desde Conciliación.</p>
          <div className="flex justify-end gap-2">
            <Button variant="outline" data-testid="invoice-pay-cancel" onClick={onClose}>Cancelar</Button>
            <Button data-testid="invoice-pay-confirm" onClick={confirm}
              className="bg-[#D9381E] hover:bg-[#B91C1C] text-white">Registrar</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
